import { useAuthContext } from '@contexts/authContext'
import { MapView } from '@contexts/mapDataContext'
import styled from '@emotion/styled/macro'
import { size } from '@styles/theme'

import { ImageUploadLabel, ImageUploadText, Section } from './SharedFormComponents'
import ImageUploadButton from '@elements/ImageUploadButton'
import { thumbnailMediumNoFallback } from '@utils/thumbnails'

const BackgroundImageLabel = styled(ImageUploadLabel)`
  display: flex;
  flex-direction: column;
  gap: ${size(2)};
  width: 100%;
`

const backgroundImageButtonSlotProps = {
  containerButton: {
    style: {
      borderRadius: '20px',
      flexGrow: 1,
      flexShrink: 0,
      width: '100%',
      height: size(17.5)
    }
  }
}

const SocialImageForm = ({ setUser }) => {
  const { state: authState, handleInstantUpdate } = useAuthContext()

  const handleRemovalSuccess = (accessor) => {
    const updatedUser = { ...authState?.user }
    delete updatedUser?.socialMedia?.[accessor]
    handleInstantUpdate(updatedUser)
    MapView.updateUser(updatedUser?.nearbyUuid, updatedUser)
    if (typeof setUser === 'function') setUser(updatedUser) // <-- Local to own profile
  }

  const handleImageUpdateSucess = (updatedUser) => {
    if (typeof setUser === 'function') setUser(updatedUser) // <-- Local to own profile
  }

  return (
    <Section>
      <BackgroundImageLabel>
        <ImageUploadText style={{ alignSelf: 'flex-start' }}>Profile Background</ImageUploadText>
        <ImageUploadButton
          slots={backgroundImageButtonSlotProps}
          useImageIcon
          headerText='Crop Image'
          aspect={2/1}
          existingUrl={authState?.user?.socialMedia?.profile_background?.url}
          btnSize={size(8)}
          uniqueDialogType='social_background'
          onUpdateSuccess={handleImageUpdateSucess}
          onRemovalSuccess={() =>
            handleRemovalSuccess('profile_background')
          }
          formatRemovalParams={() => ({
            params: {
              roles: ['social_profile_background']
            }
          })}
          formatRequestData={(_, croppedFile) => {
            const formData = new FormData()
            formData.append('user_is_parent', true)
            formData.append('files[]', croppedFile)
            formData.append('roles[]', 'social_profile_background')
            return formData
          }}
        />
      </BackgroundImageLabel>
      <br />
      <ImageUploadLabel>
        <ImageUploadButton
          headerText='Crop Image'
          existingUrl={thumbnailMediumNoFallback(authState?.user?.socialMedia?.thumbnail)}
          btnSize={size(10)}
          uniqueDialogType='social_main'
          onUpdateSuccess={handleImageUpdateSucess}
          onRemovalSuccess={() =>
            handleRemovalSuccess('thumbnail')
          }
          formatRemovalParams={() => ({
            params: {
              roles: [
                'social_profile_small',
                'social_profile_medium',
                'social_profile_large',
              ]
            }
          })}
          formatRequestData={(_, croppedFile) => {
            const formData = new FormData()
            formData.append('user_is_parent', true)
            formData.append('treat_as_set', true)
        
            formData.append('files[]', croppedFile)
            formData.append('roles[]', 'social_profile_large')
            
            formData.append('files[]', croppedFile)
            formData.append('roles[]', 'social_profile_medium')

            formData.append('files[]', croppedFile)
            formData.append('roles[]', 'social_profile_small')
            return formData
          }}
        />
        <ImageUploadText>+ Main Picture</ImageUploadText>
      </ImageUploadLabel>
    </Section>
  )
}

export { SocialImageForm }
